<div class="flex flex-col gap-3 h-full min-h-0">
  <div class="flex items-center gap-2 shrink-0">
    <input
      type="text"
      class="w-full rounded border border-surface-switch-300 px-3 py-2 text-sm bg-surface-switch-0"
      placeholder="Search blueprints by name"
      [value]="searchTerm"
      (input)="onSearchTermChanged($any($event.target).value)"
    />
  </div>

  @if (filteredBlueprints.length === 0) {
    <div class="text-sm text-muted-color py-6 text-center flex-1">
      No blueprints match your search.
    </div>
  } @else if (visibleSuggestions.length === 0) {
    <div
      class="flex-1 min-h-0 overflow-y-auto border border-surface-switch-200 rounded-md"
    >
      @for (blueprint of filteredBlueprints; track blueprint.id) {
        <ng-container
          [ngTemplateOutlet]="blueprintRow"
          [ngTemplateOutletContext]="{ $implicit: blueprint, suggestion: null }"
        />
      }
    </div>
  } @else {
    <div class="flex-1 min-h-0 overflow-y-auto flex flex-col gap-4">
      <div>
        <div
          class="mb-2 flex items-center gap-2 text-xs font-semibold tracking-wide text-muted-color"
        >
          <i class="pi pi-sparkles" aria-hidden="true"></i>
          <span class="uppercase">Suggested for this drawing</span>
        </div>
        <div class="border border-surface-switch-200 rounded-md">
          @for (match of visibleSuggestions; track match.blueprint.id) {
            <ng-container
              [ngTemplateOutlet]="blueprintRow"
              [ngTemplateOutletContext]="{
                $implicit: match.blueprint,
                suggestion: match,
              }"
            />
          }
        </div>
      </div>

      @if (otherBlueprints.length) {
        <div>
          <div
            class="mb-2 text-xs font-semibold tracking-wide text-muted-color uppercase"
          >
            All blueprints
          </div>
          <div class="border border-surface-switch-200 rounded-md">
            @for (blueprint of otherBlueprints; track blueprint.id) {
              <ng-container
                [ngTemplateOutlet]="blueprintRow"
                [ngTemplateOutletContext]="{
                  $implicit: blueprint,
                  suggestion: null,
                }"
              />
            }
          </div>
        </div>
      }
    </div>
  }
</div>

<ng-template #blueprintRow let-blueprint let-suggestion="suggestion">
  <div class="border-b border-surface-switch-200 last:border-b-0">
    <div
      class="w-full p-3 hover:bg-surface-switch-50"
      [class.bg-primary-50]="isSelected(blueprint.id)"
      (click)="onBlueprintClick(blueprint)"
    >
      <div class="flex items-center justify-between gap-3">
        <div class="min-w-0 text-left flex-1">
          <div class="flex flex-wrap items-center gap-2">
            <div class="font-semibold truncate">
              {{ blueprint.name }}
            </div>
            @if (suggestion?.best) {
              <span
                class="inline-flex items-center gap-1 rounded-full bg-surface-switch-100 px-2 py-0.5 text-xs font-medium"
              >
                <i class="pi pi-sparkles text-xs" aria-hidden="true"></i>
                Best match
              </span>
              <span class="text-xs font-medium text-green-500">
                {{ suggestionPercent(suggestion.confidence) }}
              </span>
            } @else if (suggestion) {
              <span
                class="rounded-full bg-surface-switch-100 px-2 py-0.5 text-xs font-medium text-muted-color"
              >
                {{ suggestionPercent(suggestion.confidence) }}
              </span>
            }
          </div>
          <div class="text-xs text-muted-color truncate">
            Created: {{ blueprint.created_date | date: "medium" }} | Creator:
            {{
              blueprint.creator ||
                (blueprint.preset ? "Preset Blueprint" : "Unknown")
            }}
            | Material:
            {{ blueprint.default_material_name || "None" }} | Items:
            {{ blueprint.items?.length ?? 0 }}
          </div>
          @if (suggestion?.reason) {
            <div class="mt-1 flex items-start gap-1 text-xs text-sky-400">
              <i class="pi pi-lightbulb mt-0.5" aria-hidden="true"></i>
              <span>{{ suggestion.reason }}</span>
            </div>
          }
        </div>
        <div class="flex items-center gap-4 shrink-0">
          <button
            type="button"
            class="inline-flex items-center rounded p-1 text-xs text-muted-color transition-colors hover:bg-surface-switch-100 hover:text-surface-switch-800"
            (click)="$event.stopPropagation(); toggleExpand(blueprint)"
            aria-label="Toggle items"
          >
            <i
              class="pi text-xs"
              [class.pi-chevron-down]="isExpanded(blueprint)"
              [class.pi-chevron-right]="!isExpanded(blueprint)"
            ></i>
          </button>
          <i
            class="pi pointer-events-none"
            [class.pi-check-circle]="isSelected(blueprint.id)"
            [class.pi-circle]="!isSelected(blueprint.id)"
          ></i>
        </div>
      </div>
    </div>

    @if (isExpanded(blueprint)) {
      <div
        class="mx-3 mb-3 rounded border border-surface-switch-200 bg-surface-switch-50 px-3 py-2"
      >
        @if (blueprint.items && blueprint.items.length > 0) {
          <div class="space-y-2">
            @for (item of getRootItems(blueprint); track item.id) {
              <app-blueprint-item-viewer
                [blueprintItem]="item"
                [blueprint]="blueprint"
                [blueprintMap]="blueprintMap"
              />
            }
          </div>
        } @else {
          <div class="text-xs text-surface-switch-500 italic">
            (Empty blueprint)
          </div>
        }
      </div>
    }
  </div>
</ng-template>
